<!-- <p>save-user-dialog works!</p> -->
<h1 mat-dialog-title>Saving New User</h1>
<mat-dialog-content class="mat-typography">
  <div class="save-user-dialog-status">
    <i>Please wait while Saving user Details!</i>
    <mat-spinner></mat-spinner>
  </div>

  <mat-divider></mat-divider>
</mat-dialog-content>
